
 import * as React from 'react';
 import {createComponent} from '@lit/react';
 
 import {ObiSnow as ObiSnowElement} from '@oicl/openbridge-webcomponents/dist/icons/icon-snow.js';
 
 
 

 
 export const ObiSnow = createComponent({
   react: React,
   tagName: 'obi-snow',
   elementClass: ObiSnowElement,
   events: {
     
   }
  });
 
 